import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import MetricsSection from './components/MetricsSection';
import ServicesSection from './components/ServicesSection';
import CapabilitiesSection from './components/CapabilitiesSection';
import ContactFooter from './components/ContactFooter';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <PhilosophySection />
      <MetricsSection />
      <ServicesSection />
      <CapabilitiesSection />
      <ContactFooter />
    </main>
  );
}